// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ja'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false
Vue.use(ElementUI, { locale })
Vue.use(VueMaterial)
Vue.use(VueMaterial.MdIcon)

Vue.material.registerTheme({
  default: {
    primary: 'grey',
    accent: 'blue'
  },
  shop_requests: {
    primary: 'blue-grey',
    accent: 'white'
  },
  admin: {
    accent: 'red',
    default: 'green',
    primary: 'bule',
    indigo: 'orange'
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDQAB8j7Zl71JMBpABXcKJtLHM2Jm_807I',
    libraries: 'places'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js